import {DetailsInformationObservedField} from '@/components/commons/details-information-observed-field/DetailsInformationObservedField'
import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {z} from 'zod'
import {PatientExtended, PatientPrivacyFormValidationSchema} from '@/features/patients/types'
import {PatientDetailsConsent} from '@/features/patients/components/patient-details-consent/PatientDetailsConsent'
import {formatDate} from '@/dayjs'

type PatientPrivacyFormValidationKey = keyof z.infer<typeof PatientPrivacyFormValidationSchema>

export const PatientPrivacyDetails = ({patient}: {patient: PatientExtended}) => {
    const {t} = useTranslation()
    return (
        <Flexbox direction="column" gap={2}>
            <DetailsField>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:fm01')}
                </Text>
                <DetailsInformationObservedField<PatientPrivacyFormValidationKey>
                    name="fm01"
                    value={patient.fm01 && t('commons:signed')}
                />
            </DetailsField>
            <Flexbox gap={6} align="center">
                <PatientDetailsConsent value={patient.privacy1} label="patients:orientation_advice" />
                <PatientDetailsConsent value={patient.privacy2} label="patients:notifications_events" />
                <PatientDetailsConsent value={patient.privacy3} label="patients:sending_questionnaires" />
                <PatientDetailsConsent value={patient.privacy4} label="patients:sending_sms" />
            </Flexbox>
            {patient.consentDateFm01 && (
                <Text palette="neutral" shade="500" size="textSm">
                    {t('patients:consent_date_value', {
                        date: formatDate(patient.consentDateFm01, 'DD/MM/YYYY')
                    })}
                </Text>
            )}
        </Flexbox>
    )
}
